import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentHeader } from '../../../layout/Content'
import Searchbar from '../../../layout/searchbar/Searchbar'
import ToolbarButton from '../../../layout/ToolbarButton'
import POController from '../po/POController'
import POListHeaderStyle from './css/POListHeaderStyle'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import POListSettingsForm from './POListSettingsForm'
import { appContext } from '../../../../App'
import { poListControllerContext } from './POListController'

function POListToolbar(props) {
  const app = useContext(appContext)
  const searchInput = props.searchInput[0]
  const setContent = app.content[1]
  const poListController = useContext(poListControllerContext)
  const { reloadPOList, selectedPOId, batchDeleteSelectedPO }  = poListController

  const onClickSettings = () => {
    ReactDOM.render(
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <POListSettingsForm app={app} poListController={poListController} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickTrash = (e) => {
    const showTrashMessageBox = () => {
      const onClick = (button) => {
        if (button === 'Yes') batchDeleteSelectedPO()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='33'
          width='35'
          header="Deleting Purchase Orders..."
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Will delete all selected/checked Purchase Orders records.</div>
              <br />
              <div>Do you want to continue?</div>
              <br />
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
          </ModalWindow>,
          document.getElementById('modal-form-container')
      )
    }

    showTrashMessageBox()
  }

  return (
    <ToolbarButton>
      <button
        id='refresh-list'
        name='tb'
        disabled={searchInput}
        className={ searchInput ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        onClick={() => reloadPOList()}>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        id='settings'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={onClickSettings}>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        id='new-po'
        name='tb'
        className='pospro-action-btn toolbar-btn'
        onClick={() => setContent(<POController />)}>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>New P.O.</span>
      </button>
      <button
        id='batch-delete'
        name='tb'
        className={ selectedPOId.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        disabled={!selectedPOId.length}
        onClick={onClickTrash}>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch Delete</span>
      </button>
    </ToolbarButton>
  )
}

function POListHeader() {
  const poListController = useContext(poListControllerContext)
  const { filterPOList } = poListController
  const [searchPOList, setSearchPOList] = useState('')

  const searchbarProps = {
    search: searchPOList,
    setSearch: setSearchPOList,
    filter: filterPOList
  }

  return (
    <ContentHeader title='Purchase Order Transactions List'>
      <div id='po-list-toolbar'>
        <Searchbar { ...searchbarProps }/>
        <POListToolbar searchInput={searchPOList}/>
      </div>
      <POListHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(POListHeader)